import ResponsiveImage from "../modules/responsive-image";

export default function TemplateMySamsam({page}) {
    return <>
        <div className="tw-relative tw-aspect-[4/5] lg:tw-aspect-[20/9]">
            <figure className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-overflow-hidden">
                {page.extra_fields.image &&
                    <ResponsiveImage
                        image={page.extra_fields.image}
                        classes="tw-object-cover tw-w-full tw-h-full"
                        layout="fill"
                    />}
            </figure>
            <div className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-black/30"></div>
        </div>
        <div className="container">
            <div className="tw-flex tw-flex-wrap tw-gap-y-10 -tw-mx-7 -tw-mt-52 tw-relative">
                {page.extra_fields.boxes && page.extra_fields.boxes.length && page.extra_fields.boxes.map((box) => {
                    return (
                        <div className="tw-w-full lg:tw-w-1/2 tw-px-7" key={box.black_text}>
                            <a href={box.url} target="_blank"
                               className="tw-group tw-no-underline tw-text-inherit hover:tw-text-inherit hover:-tw-translate-y-2 tw-transition tw-flex tw-items-end tw-gap-y-6 lg:tw-gap-y-10 tw-justify-between tw-bg-white tw-rounded-3xl tw-shadow-2xl tw-py-16 lg:tw-py-20 tw-px-10 lg:tw-px-12">
                                <div className="tw-w-full lg:tw-w-auto">
                                    {box.black_text &&
                                        <p className="tw-text-[30px] lg:tw-text-[40px] tw-font-bold tw-pb-0 tw-leading-tight"
                                           key={box.black_text}>{box.black_text}</p>}
                                    {box.green_text &&
                                        <p className="tw-text-[30px] lg:tw-text-[40px] tw-text-green tw-font-light tw-leading-tight tw-pb-0 lg:tw-pb-10"
                                           key={box.green_text}>{box.green_text}</p>}
                                </div>
                                <div
                                    className="tw-flex tw-items-center tw-justify-center tw-bg-green group-hover:tw-bg-green/80 tw-transition tw-px-12 tw-py-5 tw-rounded-full tw-shadow-[0.1rem_0.3rem_0_rgba(110,162,77,.5)]">
                                    <span className="tw-uppercase tw-text-white tw-font-bold tw-text-[14px] lg:tw-text-[16px] tw-tracking-wide">Inloggen</span>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </div>
            <div className="tw-text-center tw-pt-32 tw-pb-10 lg:tw-pb-0">
                {page.extra_fields.bottom.title &&
                    <h2 className="tw-text-[26px] lg:tw-text-[30px] tw-text-black tw-pb-4">{page.extra_fields.bottom.title}</h2>}
                {page.extra_fields.bottom.content &&
                    <div className="tw-mx-auto lg:tw-w-1/2 [&_a]:tw-font-bold"
                         dangerouslySetInnerHTML={{__html: page.extra_fields.bottom.content}}></div>}
            </div>
        </div>
    </>;
}